export const formValidation = (() => {
    const form = document.getElementById('tokenForm');

    if (!form) return;

    const telErrorDiv = form.querySelector("#tel-validation-error");
    const emailErrorDiv = form.querySelector("#email-validation-error");

    const newsLetterSelector = form.querySelector('#NewsletterLabelButton');

    if (newsLetterSelector) {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        var observer = new MutationObserver(validateForm);
        observer.observe(newsLetterSelector, {
            childList: true
        });
    }

    const requiredInputs = form.querySelectorAll('input[required]');

    requiredInputs.forEach(input => {
        input.addEventListener('input', validateForm);
        input.addEventListener('change', validateForm);
    });

    function validateForm() {
        let isValid = true;
        const submitButton = document.getElementById('btn-submit-form');

        if (newsLetterSelector) {
            if (newsLetterSelector.textContent.indexOf('V\u00E4lj nyhetsbrev') > -1) {
                isValid = false;
            }
        }

        requiredInputs.forEach(input => {
            const type = input.type;
            const val = input.value.trim();
            const isRequired = input.hasAttribute('required');
            let isCurrent = input === document.activeElement;

            if (input === document.activeElement) {
            }

            if (type === 'checkbox') {
                if (isRequired && !input.checked) {
                    isValid = false;

                    return;
                }
                return; // Skip the rest of the checks for checkboxes
            }

            // Skip validation for empty, non-required fields
            if (!isRequired && val === '') {
                return;
            }

            // If required and empty, invalid
            if (isRequired && val === '') {
                isValid = false;
                return;
            }

            // Type-specific checks (only if there's a value)

            if (type === 'email') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(val)) {
                    isValid = false;

                    if (!isCurrent && emailErrorDiv) {
                        emailErrorDiv.style.display = "block";
                    }
                    else if (emailErrorDiv) {
                        emailErrorDiv.style.display = "none";
                    }

                    return;
                } else if (emailErrorDiv) {
                    emailErrorDiv.style.display = "none";
                }
            }

            if (type === 'tel') {
                const telRegex = /^[\d\s()+-]+$/;
                if (!telRegex.test(val)) {
                    isValid = false;

                    if (!isCurrent && telErrorDiv) {
                        telErrorDiv.style.display = "block";
                    }
                    else if (telErrorDiv) {
                        telErrorDiv.style.display = "none";
                    }

                    return;
                } else if (telErrorDiv) {
                    telErrorDiv.style.display = "none";
                }
            }

            if (type === 'number') {
                if (isNaN(val)) {
                    isValid = false;
                    return;
                }
            }
        });

        if (submitButton && isValid) {
            submitButton.classList.remove('btn--disabled')
        } else if (submitButton && !isValid) {
            submitButton.classList.add('btn--disabled')
        }

    };
})();
